import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';
import EditorReadOnly from '../../../../common/EditorPlus/EditorReadOnly.container';
import PostUserBanner from '../../../../UserBanner/PostUserBanner/PostUserBanner.container';
import CommentsFeed from '../PostComment/CommentsFeed';
import TagList from '../TagList/TagList.container';
import Reactions from '../../../../Reactions/Reactions.container';
import { isScheduledPost } from '../../../../../../../core/utils/posts';

import cellStyle from './style';

@Radium
class PostCell extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showReadMore: false,
      nothing: false,
    };

    this.addTag = this.addTag.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { post } = this.props;
    const { nothing } = this.state;
    if (
      nextProps.post.editedAt !== post.editedAt ||
      nextProps.post.important !== post.important
    ) {
      setTimeout(() => {
        this.setState({ nothing: !nothing }); // force rerender
      }, 0);
    }
  }

  addTag() {
    this.setState({ showTags: true });
  }

  render() {
    const {
      post,
      showComments,
      toggleReaction,
      isReadOnlyUser,
      isRecentImportant,
      style,
    } = this.props;
    const isScheduled = isScheduledPost(post);

    const { showReadMore, showTags } = this.state;

    const renderContent = (content) => {
      const marginBottom = showReadMore ? 0 : 15;
      return (
        <div style={{ ...cellStyle.contentSection, marginBottom }}>
          {content}
        </div>
      );
    };

    const content = post.content ? JSON.parse(post.content) : undefined;
    let testId = 'post-element';
    if (post.important) {
      testId = `post-element-${
        isRecentImportant ? 'important-recent' : 'important'
      }`;
    }
    if (!content) return null;
    return (
      <div style={{ ...cellStyle.container, ...style }}>
        <div
          style={{
            ...cellStyle.cell,
            border: isRecentImportant
              ? `1px solid ${colors.designSystem.purple50}`
              : '',
          }}
          data-testid={`${testId}`}
        >
          <PostUserBanner post={post} addTag={this.addTag} />
          {post.tags.length || showTags ? (
            <div style={{ float: 'left', width: '100%' }}>
              <div style={{ ...cellStyle.separator, marginBottom: 0 }} />
              <TagList post={post} />
              <div
                style={{ ...cellStyle.separator, marginTop: 0, float: 'left' }}
              />
            </div>
          ) : (
            <div style={cellStyle.separator} />
          )}
          <div style={cellStyle.previewPostSection}>
            {content
              ? renderContent(
                  <div>
                    <EditorReadOnly
                      rawEditorState={JSON.parse(post.content)}
                      uniqueId={post.objectId}
                    />
                  </div>
                )
              : null}
            {post.editedAt ? (
              <div style={cellStyle.edited}>(Edited)</div>
            ) : null}
          </div>
          {!isScheduled && (
            <React.Fragment>
              <Reactions
                sequenceId={`post-${post.objectId}`}
                itemId={post.objectId}
                toggleReaction={toggleReaction}
                style={{ marginBottom: 15 }}
                readOnly={isReadOnlyUser}
              />
              <div style={cellStyle.commentsContainer}>
                <CommentsFeed
                  postId={post.objectId}
                  showComments={showComments}
                  readOnly={isReadOnlyUser}
                />
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

PostCell.propTypes = {
  classId: PropTypes.string.isRequired,
  post: PropTypes.shape({
    objectId: PropTypes.string.isRequired,
    tags: PropTypes.arrayOf(PropTypes.object).isRequired,
    content: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    important: PropTypes.bool,
    createdAt: PropTypes.string.isRequired,
    editedAt: PropTypes.string,
    scheduledFor: PropTypes.string,
  }).isRequired,
  showComments: PropTypes.bool,
  toggleReaction: PropTypes.func.isRequired,
  isReadOnlyUser: PropTypes.bool.isRequired,
  isRecentImportant: PropTypes.bool,
  style: PropTypes.object,
};

PostCell.defaultProps = {
  showComments: false,
  isRecentImportant: false,
  style: {},
};

export default PostCell;
